/**
 * Applies the SSN masking (XXX-XX-XXXX) to a raw string of digits.
 * This function cleans the input, limits the length, and inserts dashes.
 *
 * @param {string} rawValue - The input value from the TextField event.
 * @returns {string} The formatted SSN string.
 */
export const formatSsn = (rawValue: string): string => {
  const digitsOnly = rawValue.replace(/\D/g, '').substring(0, 9);

  if (digitsOnly.length <= 3) {
    return digitsOnly;
  }

  if (digitsOnly.length <= 5) {
    return `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3)}`;
  }

  return `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3, 5)}-${digitsOnly.slice(5)}`;
};

/**
 * Regex for validating UUID format (v1-v5, case-insensitive).
 */
export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Check if a string is a valid UUID.
 */
export const isValidUuid = (value: string): boolean => UUID_REGEX.test(value);
